module.exports = __webpack_public_path__ + "79d13b307e0ceadf245c76b1afb491c1.pdf";